import React, {useEffect, useRef} from "react";
import "./FooterStyles.css";
import {
  FaFacebookF,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";

type FooterSocialItem = {
  key: string;
  label: string;
  url: string;
  icon: React.ReactNode;
};

const footerSocials: FooterSocialItem[] = [
  {
    key: "whatsapp",
    label: "WhatsApp",
    url: "https://whatsapp.com/channel/0029VbCm3NNLCoWvgQcafl19",
    icon: <FaWhatsapp />,
  },
  {
    key: "youtube",
    label: "YouTube",
    url: "https://www.youtube.com/@language-german",
    icon: <FaYoutube />,
  },
  {
    key: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61580221163353",
    icon: <FaFacebookF />,
  },
  {
    key: "tiktok",
    label: "TikTok",
    url: "https://www.tiktok.com/@dear.language",
    icon: <FaTiktok />,
  },
];

const Footer: React.FC = () => {
  const footerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const footer = footerRef.current;
    if (!footer) return;
    const updateFooterOffset = () => {
      const height = Math.ceil(footer.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty("--app-footer-height", `${height}px`);
    };
    updateFooterOffset();
    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateFooterOffset) : null;
    observer?.observe(footer);
    window.addEventListener("resize", updateFooterOffset);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", updateFooterOffset);
      document.documentElement.style.removeProperty("--app-footer-height");
    };
  }, []);
  const currentYear = new Date().getFullYear();

  return (
    <footer ref={footerRef} className="app-footer" aria-label="Website-Fußzeile">
      <div className="app-footer-particles" aria-hidden="true">
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="app-footer-inner">
        <nav className="app-footer-socials" aria-label="Soziale Medien">
          {footerSocials.map((social) => (
            <a
              key={social.key}
              href={social.url}
              className={`app-footer-social app-footer-social-${social.key}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              title={social.label}
            >
              {social.icon}
              <span>{social.label}</span>
            </a>
          ))}
        </nav>

        <div className="app-footer-right">
          <span className="app-footer-copyright">
            © {currentYear} Dear Language. Alle Rechte vorbehalten.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;